import { request } from 'data/requests/request';

const quoteIdRequest = () => request({ type: 'quoteId', url: 'fast/cart/id', notApi: true });

export default quoteIdRequest;
